/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".card-body[_ngcontent-%COMP%]{cursor:pointer}.card-body[_ngcontent-%COMP%]   .item-title[_ngcontent-%COMP%]{font-size:1.2em}.list-thumb[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{width:74px}.site-url[_ngcontent-%COMP%]{-webkit-transition:.15s;transition:.15s}.site-url[_ngcontent-%COMP%]:hover{color:#8088b6!important;text-decoration:underline}"];
export { styles as styles };
